import { ChartTooltipProps } from "./types";
import { createSiteTooltip } from "./helpers";

export const createTooltipConfig = (unitYAxis: string): Highcharts.TooltipOptions => ({
  shared: true,
  borderRadius: 8,
  shadow: false,
  padding: 24,
  useHTML: true,
  outside: true,
  positioner(labelWidth: any, labelHeight: any, point: any) {
    return {
      x: point.plotX,
      y: point.plotY - labelHeight,
    };
  },
  formatter(this: Highcharts.TooltipFormatterContextObject) {
    const props: ChartTooltipProps = {
      x: String(this!.x),
      points: this!.points || [],
      unitYAxis,
      showClickMessage: true,
    };

    return createSiteTooltip(props);
  },
})




